// Tears down a Trumbowyg editor when its scope is destroyed.
//
// The vendored trumbowyg-ng directive (lib/thirdparty/trumbowyg/trumbowyg-ng.0.0.3.min.js) registers its
// ng-disabled watcher on scope.$parent and never calls .trumbowyg('destroy'). The survey layout screen wraps
// its editors in ng-if blocks that flip on every country-tab switch and sponsor toggle, so each teardown
// leaves a watcher on the surviving parent scope, still referencing detached editor DOM that can never be
// collected.
//
// The leak is currently masked: replacing $scope.survey wholesale destroys the ng-repeat scopes those
// watchers live on. That is incidental — reworking the refresh into an in-place merge would make it
// unbounded across a long authoring session.
//
// Patching the vendored file is not an option: it is a .min.js under lib/thirdparty/ (both excluded from
// SonarCloud analysis, which is why this went unnoticed) and any library update would overwrite it.
//
// Usage: add alongside the editor attribute —
//   <div data-trumbowyg-ng='1' data-mat-trumbowyg-cleanup data-ng-model="..."></div>
app.directive('matTrumbowygCleanup', function () {
  return {
    restrict: 'A',
    link: function (scope, element) {
      scope.$on('$destroy', function () {
        // 'trumbowyg' is the data key the plugin itself stores its instance under, and the same key it
        // guards on before initialising. Checking it avoids calling destroy on an element whose editor
        // never attached (e.g. the directive was applied but the plugin failed to load).
        if (!element.data('trumbowyg')) {
          return;
        }

        // The data key only proves the editor attached, not that destroy will complete. This runs from a
        // $destroy broadcast, and by then ngIf's $animate.leave() has usually already detached the
        // element — a state the vendored plugin was never verified against. AngularJS routes a throw here
        // to $exceptionHandler, whose default is console.error, and this portal wires no console-capture
        // integration to Sentry — so console alone would leave the failure invisible AND silently undo the
        // leak fix this directive exists for. Hence the explicit capture as well.
        // Naming the caught value error_ is required by the SonarCloud JS profile (S7718).
        try {
          element.trumbowyg('destroy');
        } catch (error_) {
          // eslint-disable-next-line no-console
          console.error('mat-trumbowyg-cleanup: destroy failed, the editor watcher may leak', error_);
          window.Sentry?.captureException(error_);
        }
      });
    }
  };
});
